export default Object.freeze(
  function previousElementSiblings(element) {
    let previousSiblings = [];
    let previousElement = element.previousElementSibling;
    while (previousElement) {
      previousSiblings.push(previousElement);
      previousElement = previousElement.previousElementSibling;
    }
    return previousSiblings;
  }
);
